module.exports = __webpack_public_path__ + "img/18.c3e7d07e.jpg";